import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import track_order_img from "../assets/images/track_order.jpg";

function Tracking() {
  const [orderId, setOrderId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleTracking = async () => {
    const toastId = "order-id";
    setErrorMessage("");

    // Validate order ID
    if (!orderId.trim()) {
      if (!toast.isActive(toastId)) {
        setErrorMessage("Order ID cannot be empty. Please enter a valid Order ID.");
      }
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders/view/${orderId.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();

      if (data.success) {
        // If order found, redirect to order details page
        navigate(`/orderdetails/${orderId.trim()}`);
      } else {
        // If order not found, show error message
        setErrorMessage("Order not found. Please check the Order ID.");
      }
    } catch (error) {
      // console.log("Error tracking order:", error);
      setErrorMessage("Unable to fetch order details. Please try again later.");
    }
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 576px) {
            .tracking-form-innr {
              flex-direction: column !important;
              border: none !important;
              padding: 0 !important;
            }
            .tracking-input-wrapper {
              border: 2px solid #6c63a4 !important;
              border-radius: 12px !important;
              padding: 5px !important;
              width: 100% !important;
            }
            .tracking-input-wrapper input {
              width: 100% !important;
            }
            .tracking-btn {
              width: 100% !important;
              margin-top: 10px !important;
            }
          }
        `}
      </style>

      {/* Banner Image Section */}
      <section className="tracking-banner">
        <img 
          src={track_order_img} 
          alt="Track Order Banner" 
          className="img-fluid w-100"
          style={{ maxHeight: '400px', objectFit: 'cover', marginTop: '100px' }}
        />
      </section>


      <section className="banner-innr">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="banner-innr-content">
                <h3>Track Your Order</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Tracking Form Section */}
      <section className="tp-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="tracking-form" style={{ 
                padding: '10px',
                backgroundColor: 'white'
              }}>
                <div className="tracking-form-innr" style={{ 
                  display: 'flex', 
                  gap: '10px',
                  border: '2px solid #6c63a4', 
                  borderRadius: '12px',
                  padding: '5px'
                }}>
                  <div className="tracking-input-wrapper" style={{ flex: 1 }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Order ID"
                      value={orderId}
                      maxLength={30}
                      onChange={(e) => setOrderId(e.target.value)}
                      style={{ 
                        border: 'none',
                        height: '38px',
                        width: '100%'
                      }}
                    />
                  </div>
                  <button
                    className="thm-btn tracking-btn"
                    onClick={handleTracking}
                    type="submit"
                    style={{ 
                      backgroundColor: '#6c63a4',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '8px 20px',
                      whiteSpace: 'nowrap',
                      minWidth: '150px'
                    }}
                  >
                    Track Order
                  </button>
                </div>
                {errorMessage && (
                  <div className="alert alert-danger mt-3" role="alert">
                    {errorMessage}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Tracking;